import React, { useContext, useEffect, useState, useRef, Fragment } from "react";
import { Dialog, Disclosure, Transition } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { useLocation, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import AppContext from "../../context/AppContext";
import { IoIosNotifications, IoMdLogOut } from "react-icons/io";
import { IoSettings } from "react-icons/io5";
import dummyImg from "../../assets/dummy.webp";
import { getUnreadMsgCount } from "../../service/Notification";
import Logout from "../common/Logout";
import LangComp from "./langComp";
import DashboardMenus from "./DashboardMenus.js";
import notification from "../../assets/notification03.png"
import logout from "../../assets/power.png"
import userProfile from "../../assets/user.png"
import { RxCross2 } from "react-icons/rx";
import translations from "../common/Translations.js";
export const MainNav = () => {
  const [showModal, setShowModal] = useState(false);
  const [userType, setUserType] = useState(null);
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);
  const context = useContext(AppContext);
  const [showProfileModal, setShowProfileModal] = useState(false)
  const {
    theme,
    profilePic,
    setProfilePic,
    setPriority,
    setActive,
    setSelectedUserId,
    setSelectedUserName,
    langMode,
    totalUnreadMsgCount,
    setTotalUnreadMsgCount,
    toggleLangMode,
  } = context;
  const user = Cookies.get("userName");
  const navbarRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  const handleReset = () => {
    setActive("Status");
    setPriority("Priority");
    setSelectedUserId('')
    setSelectedUserName("Default")
  };

  useEffect(() => {
    const profilePic = Cookies.get("profilePic") || dummyImg;
    setProfilePic(profilePic !== "null" ? profilePic : dummyImg);
    const userTypeCookie = Cookies.get("userType");
    setUserType(userTypeCookie);
  }, []);

  useEffect(() => {
    const fetchUnreadMsgCount = async () => {
      try {
        const count = await getUnreadMsgCount();
        setTotalUnreadMsgCount(count.body.value.unreadMsgCount);
      } catch (error) {
        console.error("Failed to fetch unread message count:", error);
      }
    };
    fetchUnreadMsgCount();
  }, []);

  const handleLogout = () => setShowModal(true);
  const handleViewNotifications = () => {
    Cookies.set("notipreviousPath", location.pathname);
    navigate("/notification");
    setActive("Status");
    setPriority("Priority");
    setSelectedUserId('')
    setSelectedUserName("Default")
  };
  const handleSettings = () => {
    navigate("/settings");
    handleReset();
  };

  const formatUserType = (userType) => {
    if (!userType) return "Unknown";
    switch (userType) {
      case "super_admin":
        return "Super Admin";
      case "admin":
        return "Admin";
      case "office_user":
        return "Office User";
      default:
        return userType
          .replace(/_/g, " ")
          .replace(/^./, (str) => str.toUpperCase());
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        setIsNavbarOpen(false);
      }
    };

    if (isNavbarOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isNavbarOpen]);

  return (
    <>
      <Disclosure
        as="nav"
        ref={navbarRef}
        className={`bg-white w-full shadow-none ${theme === "dark" ? "dark-mode" : ""
          }`}
      >
        {({ open }) => (
          <>
            <div className={`w-full px-4 sm:pr-0 sm:px-6 lg:px-8`}>
              <div className="flex h-16 space-x-10 lg:space-x-0 justify-end items-center">

                <div
                  className={`lg:hidden block absolute top-1 left-0 z-50`}
                >
                  <DashboardMenus />
                </div>

                <div className="hidden lg:flex md:items-center gap-1 w-full justify-end">
                  <div className="flex items-center justify-end w-full max-w-fit gap-4 ml-2">
                    <div
                      className="relative group w-[44px] h-[44px] rounded-full bg-[#EBECEF] cursor-pointer"
                      onClick={handleViewNotifications}
                    >
                      <img
                        src={notification}
                        alt="Notifications"
                        className="absolute top-[11px] left-[11px] h-[22px] w-[22px] filter brightness-75 group-hover:brightness-100"
                      />
                      <span className="absolute top-0 right-0 transform translate-x-1/2 -translate-y-1/2 bg-[#EF4A00] text-white text-xs font-semibold rounded-full w-[18px] h-[18px] flex items-center justify-center shadow-md">
                        {totalUnreadMsgCount}
                      </span>
                      <div
                        role="tooltip"
                        className="absolute right-full top-1/2 -translate-y-1/2 mr-2 z-10 invisible px-3 py-1.5 text-xs font-medium text-white bg-gray-900 rounded-lg shadow-sm opacity-0 transition-opacity duration-300 group-hover:visible group-hover:opacity-100"
                      >
                        Notification
                        <div className="tooltip-arrow" data-popper-arrow></div>
                      </div>
                    </div>
                    <LangComp toggleLangMode={toggleLangMode} isNavbarOpen={isNavbarOpen} />
                    <div className="relative " data-testid="profile-avatar">
                      <img
                        className={`w-10 h-10 p-1 rounded-full cursor-pointer ring-2 ring-gray-300 ${theme === "dark"
                          ? "bg-white"
                          : theme === "high-contrast"
                            ? "bg-white"
                            : ""
                          }`}
                        src={profilePic}
                        alt="Avatar"
                        onClick={() => {
                          Cookies.set("previousPath", location.pathname);
                          setShowProfileModal(!showProfileModal)
                          setActive("Status")
                          setPriority("Priority")
                          setSelectedUserId('')
                          setSelectedUserName("Default")
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="lg:hidden inline-flex items-center gap-4 justify-center">
                  <Disclosure.Button
                    onClick={() => setIsNavbarOpen(!isNavbarOpen)}
                    className="inline-flex items-center justify-center p-2 text-gray-400  hover:text-red-600"
                  >
                    <span className="sr-only">Open main menu</span>
                    {isNavbarOpen ? (
                      <XMarkIcon className="h-6 w-6" />
                    ) : (
                      <Bars3Icon className="h-6 w-6" />
                    )}
                  </Disclosure.Button>
                </div>
              </div>
            </div>
            <Disclosure.Panel
              className={`lg:hidden fixed inset-0 z-50 bg-black bg-opacity-50 flex justify-end overflow-hidden transition-all duration-300 ease-in-out max-h-0
              ${isNavbarOpen ? "max-h-screen overflow-auto border-l" : "max-h-0"}`}
              static
            >
              <div className="absolute right-0 h-full w-64 bg-white shadow-lg">
                <div className="p-5 flex flex-col gap-4 justify-center">
                  <button
                    onClick={() => setIsNavbarOpen(false)}
                    className="self-end p-2 hover:text-gray-500"
                  >
                    <XMarkIcon className="h-6 w-6" />
                  </button>
                  <div className="mt-3 flex flex-col gap-4 ">
                    <div className="flex flex-row space-x-5" >
                      <div className="">
                        <span
                          className={` ${theme === "dark"
                            ? "dark-mode "
                            : theme === "high-contrast"
                              ? "high-contrast  "
                              : ""
                            } font-bold text-sm`}
                        >
                          {user}
                        </span>
                        <span
                          className={`block text-gray-700 text-xs  ${theme === "dark"
                            ? "dark-mode "
                            : theme === "high-contrast"
                              ? "  "
                              : ""
                            }`}
                        >
                          {formatUserType(userType)}
                        </span>
                      </div>
                    </div>
                    <div
                      className="flex items-center gap-3 p-2 rounded-md hover:bg-gray-100 cursor-pointer transition-colors"
                      onClick={handleViewNotifications}>
                      <IoIosNotifications className="h-6 w-6 text-gray-600" />
                      <div className="flex flex-col">
                        <span className="text-sm font-medium">Notifications</span>
                        <span className="text-xs text-gray-500">
                          {totalUnreadMsgCount} unread
                        </span>
                      </div>
                    </div>
                    <div
                      className="flex items-center gap-3 p-2 rounded-md hover:bg-gray-100 cursor-pointer transition-colors"
                      onClick={handleSettings}>
                      <IoSettings className="h-6 w-6 text-gray-600" />
                      <span className="text-sm font-medium">Settings</span>
                    </div>
                    <div
                      className="flex items-center gap-3 p-2 rounded-md hover:bg-gray-100 cursor-pointer transition-colors"
                      data-testId='logout'
                      onClick={handleLogout} >
                      <IoMdLogOut className="h-6 w-6 text-gray-600" />
                      <span className="text-sm font-medium">Logout</span>
                    </div>
                  </div>
                </div>
              </div>
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>
      <Transition.Root show={showProfileModal} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-50"
          onClose={() => setShowProfileModal(false)}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity z-50" />
          </Transition.Child>
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel
                data-testid="profile-menu"
                className={`absolute transform rounded-lg shadow-xl bg-white flex flex-col gap-[16px] !max-w-[312px] !w-full h-auto !top-[7%] ${langMode === 'ar' ? '!left-[2%]' : '!right-[2%]'} py-[12px] px-[16px]`} >
                <div className=" flex flex-col gap-[3px]"
                  style={{
                    background: "linear-gradient(90deg, #E7F9FF 0%, #F2F7FD 100%)",
                    padding: "12px 16px",
                    borderRadius: "8px"
                  }}>
                  <div className="flex justify-between w-full">
                    <span
                      style={{
                        fontSize: "18px",
                        fontWeight: "600"
                      }}
                      className={` ${theme === "dark"
                        ? "dark-mode "
                        : theme === "high-contrast"
                          ? "high-contrast  "
                          : ""
                        } font-bold text-sm`}
                    >
                      {user}
                    </span>
                    <button
                      type="button"
                      className="text-gray-600 transition-transform transform hover:scale-110"
                      onClick={() => setShowProfileModal(!showProfileModal)} >
                      <RxCross2 className="h-6 w-6" />
                    </button>
                  </div>
                  <span
                    style={{
                      textAlign: "start",
                    }}
                    className={`block text-gray-700 text-xs font-medium  ${theme === "dark"
                      ? "dark-mode "
                      : theme === "high-contrast"
                        ? "  "
                        : ""
                      }`}>
                    {formatUserType(userType)}
                  </span>
                </div>
               
                <div className="relative group flex gap-[10px] cursor-pointer" data-testid="profile-menu-my-profile" onClick={() => { navigate("/user-profile"); setTimeout(() => setShowProfileModal(false), 100) }}>
                  <img src={userProfile} className="filter brightness-75 hover:text-blue-500" />
                  <div className="text-[#111827] text-base font-normal hover:text-[#4B5563]">
                    {translations[langMode].myprofile}
                    <div className="tooltip-arrow" data-popper-arrow></div>
                  </div>
                </div>
                <div className="relative group flex gap-[10px] cursor-pointer" data-testid="profile-menu-logout" onClick={handleLogout}>
                  <img src={logout} className="filter brightness-75 hover:text-blue-500" />
                  <div className="text-[#111827] font-normal text-base hover:text-[#4B5563]">
                    {translations[langMode].Logout}
                    <div className="tooltip-arrow" data-popper-arrow></div>
                  </div>
                </div>
              </Dialog.Panel> 
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
      <Logout setShowModal={setShowModal} showModal={showModal} isNavbarOpen={isNavbarOpen} />
    </>
  );
};